import { connect } from 'react-redux';
import { values, filter, includes } from 'lodash/fp';
import {
  fetchInventoryItem,
  deleteInventoryItem,
  fetchInventoryItemSkus,
  fetchInventoryItemAvailability
} from '../../../../../redux/Inventory/sagas/item/routines';
import { fetchInventoryActionOptions } from '../../../../../redux/Inventory/sagas/components/view-item/routines';
import {
  getIsFetching,
  getItemForId,
  getIsDeleting,
  getIsDeleted
} from '../../../../../redux/Inventory/selectors/item';
import {
  getIsFetching as getIsFetchingSkus,
  getSkusListForItemId
} from '../../../../../redux/Inventory/selectors/item/skus';
import {
  getIsFetchingByItem,
  getAvailabilityForItemId
} from '../../../../../redux/Inventory/selectors/item/availability';
import {
  getActionOptions,
  getIsFetchingActionOptions
} from '../../../../../redux/Inventory/selectors/components/view-item';
import { resetAuditLogsSearchQuery } from '../../../../../redux/Inventory/actions/components/audit-log-search';
import { clearInventoryItemAuditLogs } from '../../../../../redux/Inventory/actions/components/view-item';
import InventoryActions from '../../../../../constants/inventory/InventoryActions';
import { ItemType } from '../../../../../constants/inventory/InventoryTypes';
import ViewInventoryItem from '../../component';

const allowedAction = [
  InventoryActions.ADD,
  InventoryActions.REMOVE,
  InventoryActions.MOVE
];

function mapStateToProps(state, { match: { params } }) {
  const { id } = params;
  const allActionOptions = getActionOptions(state);
  const actionOptions = filter(
    ({ value }) => includes(value, allowedAction),
    allActionOptions
  );
  return {
    params,
    actionOptions,
    type: ItemType,
    item: getItemForId(state, id),
    skus: values(getSkusListForItemId(state, id)),
    availability: getAvailabilityForItemId(state, id),
    isFetching: getIsFetching(state),
    isFetchingSkus: getIsFetchingSkus(state),
    isFetchingAvailability: getIsFetchingByItem(state),
    isFetchingActionOptions: getIsFetchingActionOptions(state),
    isDeleting: getIsDeleting(state),
    isDeleted: getIsDeleted(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  const { id } = params;
  return {
    onInit: () => {
      dispatch(fetchInventoryItem({ id }));
      dispatch(fetchInventoryItemSkus(id));
      dispatch(fetchInventoryItemAvailability(id));
      dispatch(fetchInventoryActionOptions());
    },
    onDelete: item => {
      dispatch(deleteInventoryItem(item));
    },
    onUnmount: () => {
      dispatch(clearInventoryItemAuditLogs());
      dispatch(resetAuditLogsSearchQuery());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInventoryItem);
